module.exports = __webpack_public_path__ + "static/media/ionicons.854e2775.woff";